import { Content } from "@/ui";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { getGlobal } from "@/functions/getGlobal";
import { getSimplePagesStaticProps } from "@/functions/getSimplePagesStaticProps";
import { getDynamicPageStaticProps } from "@/functions/getDynamicPageStaticProps";
import useDynamicPage from "@/hooks/useDynamicPage";
import useDynamicPages from "@/hooks/useDynamicPages";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";

export default function Page({ content, prefix, title, seo, canonical, data, isBuilder = false }) {
  return (
    <>
      {isBuilder ? (
        <>
          <DynamicPageSeo
            {...seo}
            title={seo?.title.length > 0 ? seo.title : title}
            canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
          />
          <ContentBlocks data={data} prefix={prefix} />
        </>
      ) : (
        <Content items={content} logoCarousel={false} />
      )}
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPage = useDynamicPage(url_slug);
  if (builderPage) {
    return getDynamicPageStaticProps({ page: builderPage, url_slug });
  }

  return getSimplePagesStaticProps({ url_slugs });
}

export async function getStaticPaths() {
  const global = getGlobal();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPaths = useDynamicPages()
    .filter((i) => !["/"].includes(i.url_slug))
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths: [
      ...builderPaths,
      ...simple_pages_helper.toNestedPaths({
        exclude: global["_theme.simplePagesExcludeList"].split(",").map((i) => i.trim()),
      }),
    ],
    fallback: true,
  };
}
